import React from "react";

import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../../../sevices/permissions";
import { useUserPage } from "../../../../sevices/hooks/admin";

interface StepperControllerProps {
  currentStep: number;
  onSubmit: () => void;
}

const StepperController: React.FC<StepperControllerProps> = ({
  currentStep,
  onSubmit,
}) => {
  const userPageMutation = useUserPage();
  const { formattedPermissions } = usePermissions();
  const navigate = useNavigate();
  // const handleSubmit = () => {
  //   console.log("Formatted Permissions:", formattedPermissions);
  //   onSubmit();
  // };

  const handleSubmit = async () => {
    console.log(formattedPermissions, "formattedPermissions");
    // try {
    //   await userPageMutation.mutateAsync(data);
    //   // Handle successful mutation
    //   console.log("User page updated successfully");
    // } catch (error) {
    //   // Handle error
    //   console.error("Failed to update user page:", error);
    // }
  };
  return (
    <div className="flex gap-3 w-full my-8 items-center justify-between">
      <button
        disabled={currentStep === 1}
        onClick={() => navigate("/dashboard/settings?tab=Role+Management")}
        className="bg-[#fff] border border-[#0EB683] text-[#0EB683] px-8 py-2.5 rounded-2xl shadow-lg duration-100 ease-in-out disabled:text-[#BDE2D7] disabled:border-[#BDE2D7]"
      >
        Back
      </button>
      <button
        disabled={
          !formattedPermissions || !formattedPermissions.pagePermissions.length
        }
        onClick={handleSubmit}
        className="bg-[#0EB683] text-white border border-[#0EB683] px-10 py-2.5 rounded-2xl shadow-lg hover:bg-[#1aa279] duration-100 ease-in-out disabled:opacity-50"
      >
        Submit
      </button>
    </div>
  );
};

export default StepperController;
